import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { BFFHttpError } from '../model/BFFHttpError';
import type { HtmlBlock } from './model/HtmlBlock';

export const useContentAsset = (
    contentAssetId: string | undefined,
): UseQueryResult<HtmlBlock, BFFHttpError> =>
    useBffGet<HtmlBlock>(
        `/content/asset/${contentAssetId}`,
        [],
        [BffQueryKey.CONTENT_ASSET, contentAssetId ?? ''],
        {
            enabled: !!contentAssetId,
        },
    );
